var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "24px",
    viewBox: "0 0 37 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-method-WSO2",
    transform: "translate(-869.000000, -436.000000)",
    stroke: "#212A32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(473.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "generic",
    transform: "translate(396.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,0.5 C34.6903559,0.5 35.3153559,0.779822031 35.767767,1.23223305 C36.220178,1.68464406 36.5,2.30964406 36.5,3 L36.5,3 L36.5,21 C36.5,21.6903559 36.220178,22.3153559 35.767767,22.767767 C35.3153559,23.220178 34.6903559,23.5 34,23.5 L34,23.5 L3,23.5 C2.30964406,23.5 1.68464406,23.220178 1.23223305,22.767767 C0.779822031,22.3153559 0.5,21.6903559 0.5,21 L0.5,21 L0.5,3 C0.5,2.30964406 0.779822031,1.68464406 1.23223305,1.23223305 C1.68464406,0.779822031 2.30964406,0.5 3,0.5 L3,0.5 Z",
    id: "Path",
    fill: "#F0ECE9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,23 L9.5,8 C9.5,6.34314575 10.8431458,5 12.5,5 L28,5 L27.9994204,5.04157652 C26.5808489,5.27985434 25.5,6.51370428 25.5,8 L25.5,8 L25.5,23 L25.5,23",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,5 C30.1568542,5 31.5,6.34314575 31.5,8 L31.5,9 L31.5,9 L25.5,9 L25.5,8 C25.5,6.34314575 26.8431458,5 28.5,5 Z",
    id: "Rectangle-Copy-6",
    fill: "#D1CDCA"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 10,
    x2: 22,
    y2: 10,
    id: "Path-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 22,
    y2: 18,
    id: "Path-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 14,
    x2: 18,
    y2: 14,
    id: "Path-2-Copy",
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericLogo);
export default __webpack_public_path__ + "static/media/generic-logo.b1bf0d871156fd554ddd35799332efc7.svg";
export { ForwardRef as ReactComponent };